import { addIElementsToStore } from "@/store/ielements-store-utilities";
import { AppThunk } from "@/store/store";
import { GetIElementsParams, ProjectApi } from "@faro-lotv/service-wires";

export interface UpdateProjectProps {
  /** The project api client for the current project */
  projectApi: ProjectApi;

  /**
   * Query to fetch updated iElements. Should include all elements that have been expected to change,
   * but be limited to the smallest possible set to avoid long query times.
   */
  iElementQuery?: GetIElementsParams;
}

/** @returns Redux thunk that updates parts of the current project data while the application is running */
export function updateProject({
  projectApi,
  iElementQuery,
}: UpdateProjectProps): AppThunk<Promise<void>> {
  return async (dispatch) => {
    const iElements = iElementQuery
      ? await projectApi.getAllIElements(iElementQuery)
      : undefined;

    if (iElements) {
      addIElementsToStore(iElements, dispatch);
    }
  };
}
